import { useState } from "react";
import TitlePageTotvs from "../../../components/TitlePageTotvs";
import LoadingSpinner from "../../../components/LoadinSpinner";
import InputGeral from "../../../components/InputGeral/Index";
import SubmitForm from "../../../components/SubmitForm";
import { Row, Col } from "react-bootstrap";

import ConsumoTOTVS_POST from "../../../../backend/ConsumoTotvs";
import { ErroMsg, SucessoMsg } from "../../../contents/VariaveisGlobais";
import DataGrid from "../../../components/DataGrid";

function ConsultaTotvsSQL(){
    const usuarioLogado = JSON.parse(localStorage.getItem('usuarioLogado'));
    
    const [carregar, setCarregar] = useState(false);
    const [empresaFilial, setEmpresaFilial] = useState();
    const [empresaFilialSelect, setEmpresaFilialSelect] = useState();
    const [campoConsultaSQL, setCampoConsultaSQL] = useState("");
    const [dadosSQL, setDadosSQL] = useState([]);
    

    const handleEnviar = async() =>{
        let oRetorno
        const matches = [...campoConsultaSQL.matchAll(/TABELA\(([^)]+)\)/gi)];
        const tabelaSQL = matches.map(match => match[1]).join(';');

        const EmpresaParam = empresaFilial.substr(0,window._env_?.REACT_APP_TAMANHO_EMPRESA);
        const FilialParam = empresaFilial.substr(-window._env_?.REACT_APP_TAMANHO_FILIAL);

        const oJson = {
            consulta: campoConsultaSQL,
            tabelas: tabelaSQL,
            empresa: EmpresaParam,
            filial: FilialParam
        }

        const cJSON = JSON.stringify(oJson)

        setCarregar(true)
        
        if (cJSON){
            oRetorno = await ConsumoTOTVS_POST('CONSULTA', cJSON, empresaFilial)
        }

        setCarregar(false)

        if (oRetorno.error == '00'){
            SucessoMsg(oRetorno.description)
            setDadosSQL(oRetorno.data);
        }else{
            ErroMsg(oRetorno.description)
            setDadosSQL([]);
        }

        return false
    }

    const handleEmpresaFilial = (e) => {
        setEmpresaFilialSelect(e)
        setEmpresaFilial(e.value)
    }

    return (
        <>
            <Row>
                <LoadingSpinner isLoading={carregar}/>
                <Col md="12" xs="12">
                    <TitlePageTotvs 
                        text={`Execução de Consulta SQL - TOTVS`}
                        empresa={empresaFilialSelect} 
                        empresaFilial={empresaFilial} 
                        changeEmpresa={handleEmpresaFilial}
                    />
                </Col>
            </Row>
            { empresaFilial && (
                <>
                    <Row>
                        <Col md="12" xs="12">
                            <InputGeral
                                label="Consulta SQL"
                                placeholder=""
                                tipo="textArea"
                                value={campoConsultaSQL}
                                onChange={(e) => setCampoConsultaSQL(e.target.value)}
                                />
                        </Col>
                    </Row>
                    <SubmitForm 
                        onEnviar={ handleEnviar }
                        labelEnviar={"Executar Consulta"}
                        onSave={null}
                        onCancel={null}
                        onVoltar={null}
                    />
                    {dadosSQL.length > 0 && (
                        <div style={{ overflowX: 'auto', marginTop: '1rem' }}>                        
                            <p><strong>{dadosSQL.length}</strong> registros encontrados</p>
                            <DataGrid data={dadosSQL} />                        
                        </div>
                    )}
                </>
           ) }
        </>
    );
}

export default ConsultaTotvsSQL;